export enum ExtensionsCategory {
    HUB = "hub",
    SYNC = "sync",
    PAYMENT = "payment",
    BUILDER = "builder"
}

export enum ExtensionGUID {
    FINAL_PAY = "e0ebf735-abd6-4a0b-9de2-9d6850a7be50",
    VENDARA = "6c9d5475-4a82-429e-afa1-7ddc4843fc8d",
    WOOCOMMERCE = "10e4f4b0-97cd-4c39-90c2-25587c9f9ce7",
    STOCK_MANAGEMENT = "2c90e60a-bb36-46e5-b1f3-9bb157fb0241",
    METORIK = "06a63743-e8db-40ce-a6fe-14c206a112a7",
    TIME_M_SYSTEM = "c685f677-1859-42f2-bc54-83160195246a",
    ZAPIER = "8f9d58c2-9997-4f80-98fc-38f5def8ec57"
}

export type Extension = {
    _id: string;
    label: string;
    category: string;
    description: string;
    price: string;
    guid: string;
};

export type CompanyExtension = {
    _id: string;
    extensionId: string;
    companyId: string;
};

export type ExtensionsByCategory = {
    [key: string]: Extension[];
};
